import Vue from "vue";
import Element from "element-ui";
import PopupManager from "element-ui/lib/utils/popup/popup-manager";
PopupManager.zIndex = 30000;
Vue.use(Element, { size: "medium", zIndex: 3000 });
